import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import NewsCard from "@/components/NewsCard";
import { Bookmark } from "lucide-react";

export default function Bookmarks() {
  const { user } = useAuth();
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user || user === false) return;
    (async () => {
      try {
        const { data } = await api.get("/bookmarks");
        setArticles(data);
      } finally {
        setLoading(false);
      }
    })();
  }, [user]);

  if (!user || user === false) {
    return (
      <div className="text-center py-24">
        <p className="text-muted-foreground font-kannada-body">
          ಬುಕ್‌ಮಾರ್ಕ್‌ಗಳನ್ನು ನೋಡಲು{" "}
          <Link to="/login" className="text-primary font-semibold underline underline-offset-4">ಲಾಗಿನ್</Link> ಮಾಡಿ.
        </p>
      </div>
    );
  }

  return (
    <div>
      <div className="border-b-2 border-primary pb-4 mb-8">
        <div className="font-ui text-xs uppercase tracking-[0.3em] text-muted-foreground flex items-center gap-2">
          <Bookmark className="w-3 h-3" /> Bookmarks
        </div>
        <h1 className="font-kannada-heading text-4xl mt-1">ನಿಮ್ಮ ಉಳಿಸಿದ ಸುದ್ದಿಗಳು</h1>
      </div>
      {loading ? (
        <p className="text-muted-foreground">ಲೋಡ್ ಆಗುತ್ತಿದೆ...</p>
      ) : articles.length === 0 ? (
        <div className="text-center py-24 text-muted-foreground font-kannada-body">
          ಯಾವುದೇ ಬುಕ್‌ಮಾರ್ಕ್ ಇಲ್ಲ. ಇಷ್ಟದ ಸುದ್ದಿಯನ್ನು ಉಳಿಸಿ!
        </div>
      ) : (
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-testid="bookmarks-grid">
          {articles.map((a, i) => (
            <NewsCard key={a.id} article={a} index={i} />
          ))}
        </div>
      )}
    </div>
  );
}
